module.exports = __webpack_public_path__ + "img/百合.01b2880a.jpg";